﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import type { AccessDeniedPageCustomizations } from "~base/Components/Pages/Account/AccessDenied";
import { adminMenu } from "~prad/Components/Pages/Home/Start";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default {
    logoutButtonUrl: "/Home/EndSession?redirect=true",
    logoutButtonTextCode: "VisiFinance.UI.Main.Tillbaka",
    adminMenu: adminMenu,
} as AccessDeniedPageCustomizations;
